(() => {
  if (window.hkManufacturerNumberLoaded) return;
  window.hkManufacturerNumberLoaded = true;
  document.addEventListener('on:variant:change', (event) => {
    const picker = event.target.closest('variant-picker');
    if (!picker || picker.closest('.js-quickbuy, .cc-featured-product')) return;
    const productUrl = picker.dataset.url;
    document.querySelectorAll('[data-hk-manufacturer-number]').forEach((row) => {
      if (row.dataset.productUrl !== productUrl) return;
      const sku = event.detail?.variant?.sku || '';
      row.querySelector('[data-hk-manufacturer-value]').textContent = sku;
      row.hidden = !sku;
      if (sku) row.style.removeProperty('display');
      else row.style.setProperty('display', 'none', 'important');
    });
  });
})();
